
import Component from '../../../assets/scripts/modules/component'
import fireCustomEvent from '../../../vendor/scripts/fabrique/modules/fire-custom-event'
import dragula from 'dragula'

class InteractivePuzzleComponent extends Component {
  init () {
    this.instance = null
    this.touchDevice = false

    this.sources = [...this.element.querySelectorAll('.interactive-puzzle__drag-source')]
    this.targets = [...this.element.querySelectorAll('.interactive-puzzle__drag-target')]
    this.button = this.element.querySelector('.interactive-puzzle__button--check')
    this.results = this.element.querySelector('.interactive-puzzle__results')

    if (!this.sources.length || !this.targets.length || !this.button || !this.results) {
      return
    }

    this.messages = this.results.getAttribute('data-messages')
    this.messages = this.messages.length ? JSON.parse(this.messages) : ['0 goed', '1 goed', 'meerdere goed', 'alles goed!']

    this.initDragging()
    this.initButton()

    window.addEventListener('touchstart', () => {
      this.touchDevice = true
    })
  }

  initDragging () {
    this.instance = dragula([...this.sources, ...this.targets], {
      direction: 'vertical',
      // Don't allow cards in the correct spot to be dragged away after checking
      moves: (element, source, handle, sibling) => !source.classList.contains('interactive-puzzle__drag-target--correct'),
      // Don't allow dropping if the target already has a card
      accepts: (element, target, source, sibling) => !target.querySelector('.interactive-puzzle__card')
    })

    this.instance.on('drag', () => this.touchDevice && document.documentElement.classList.add('prevent-scrolling'))
    this.instance.on('dragend', () => this.touchDevice && document.documentElement.classList.remove('prevent-scrolling'))
  }

  initButton () {
    if (!this.button) {
      return
    }

    this.button.addEventListener('click', () => this.doCheck())
  }

  doCheck () {
    if (!this.results) {
      return
    }

    this.results.classList.remove('interactive-puzzle__results--visible')

    let count = 0
    this.targets.forEach(target => {
      const card = target.querySelector('.interactive-puzzle__card')
      const sourceId = target.getAttribute('data-drag-source')

      if (card && sourceId && card.id === sourceId) {
        target.classList.add('interactive-puzzle__drag-target--correct')
        count++
      } else {
        target.classList.remove('interactive-puzzle__drag-target--correct')

        // Put the card back
        const emptySource = this.sources.filter(source => !source.querySelector('.interactive-puzzle__card'))[0]
        if (emptySource) {
          const targetCard = target.querySelector('.interactive-puzzle__card')
          const sourcePlaceholder = emptySource.children[emptySource.children.length - 1]

          if (targetCard && sourcePlaceholder) {
            emptySource.insertBefore(targetCard, sourcePlaceholder)
          }
        }
      }
    })

    // Update message
    if (!this.targets.length || count === 0) {
      this.results.innerText = (this.messages[0]).replace('$i', count)
    } else if (count === this.targets.length) {
      this.results.innerText = (this.messages[3]).replace('$i', count)
      this.button.classList.add('interactive-puzzle__button--hidden')
    } else if (count === 1) {
      this.results.innerText = (this.messages[1]).replace('$i', count)
    } else if (count > 1) {
      this.results.innerText = (this.messages[2]).replace('$i', count)
    } else {
      this.results.innerText = (this.messages[0]).replace('$i', count)
    }

    this.results.classList.add('interactive-puzzle__results--visible')
  }
}

window.addEventListener('init-load', () => {
  for (const element of document.querySelectorAll('.interactive-puzzle')) {
    element.instance = element.instance || new InteractivePuzzleComponent(element)
  }
})
